<template lang="pug">
  .default_layout
    global-header(
      @switchNavigation="switchNavigation"
      :isHamburgerOpend="isHamburgerOpend")
    .service_container
      .overlay(
        v-if="isHamburgerOpend"
        :isHamburgerOpend="isHamburgerOpend"
        @click="switchNavigation()")
      global-navigation(
        @switchNavigation="switchNavigation"
        @closeNavigation="closeNavigation"
        :class="{ 'is_active' : isHamburgerOpend }")
      .content_container
        router-view
</template>

<script>

import GlobalHeader from '@/components/GlobalHeader.vue'
import GlobalNavigation from '@/components/GlobalNavigation.vue'

export default {
  name: 'default',
  components: {
    GlobalHeader,
    GlobalNavigation
  },
  data: function(){
    return {
      isHamburgerOpend: false
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenWidth)
  },
  destroyed(){
    window.removeEventListener("resize", this.checkScreenWidth)
  },
  methods: {
    checkScreenWidth(){
      const mql = window.matchMedia( '(max-width: 560px)' )
      if( !mql.matches ) {
        this.closeNavigation()
      }
    },
    switchNavigation() {
      this.isHamburgerOpend = !this.isHamburgerOpend

      const body = document.body

      if( this.isHamburgerOpend ) {
          this.scrollY = window.pageYOffset
          body.style.position = 'fixed'
          body.style.top = '-' + this.scrollY + 'px'
          body.style.width = '100%'
      } else {
          body.style.position = ''
          body.style.top = ''
          body.style.width = ''
          window.scrollTo(0, this.scrollY)
          this.scrollY = 0
      }
    },
    closeNavigation() {
      this.isHamburgerOpend = false

      const body = document.body

      body.style.position = ''
      body.style.top = ''
      body.style.width = ''
      window.scrollTo(0, this.scrollY)
      this.scrollY = 0
    }
  }
}
</script>
